// The table standard, in numbers. DataTable keeps it for every list; the
// hand-built grids (hiring, access, weekly volume) read the same values so
// a header or a row looks the same wherever it is.
//
// - Header text: one line, small, bold, uppercase, grey (the theme's
//   MuiTableCell head). A name too long for its column gets a short label
//   and the full name in a tooltip, never a second line.
// - Header rows: 40px for the column names; 32px for a group row above them.
// - Body rows: 48px, or 60px when a row carries a second grey line.

export const ROW_HEIGHT = 48;
export const TWO_LINE_ROW_HEIGHT = 60;
export const HEAD_ROW_HEIGHT = 40;
export const GROUP_ROW_HEIGHT = 32;

/** Header text, matching theme.components.MuiTableCell.head. */
export const HEAD_TEXT = {
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  color: 'grey.500',
} as const;

/** The header's ground — opaque, so a frozen header hides what scrolls under it. */
export const HEAD_BG = 'grey.50';
